"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var LAST_TD_END_REGEX = /<\/\s*td\s*>((?!<\/\s*tr\s*>)[\s\S])*$/i;
var LAST_TR_END_REGEX = /<\/\s*tr\s*>((?!<\/\s*table\s*>)[\s\S])*$/i;
var LAST_TR_REGEX = /<tr[^>]*>[^<]*/i;
var LAST_TABLE_REGEX = /<table[^>]*>[^<]*/i;
var DEFAULT_BORDER_STYLE = 'solid 1px #d4d4d4';
/**
 * @internal
 * Convert pasted content from Excel, add borders when source doc doesn't have a border
 * @param doc HTML Document which contains the content from Excel
 */
function convertPastedContentFromExcel(event) {
    var _a;
    var fragment = event.fragment, sanitizingOption = event.sanitizingOption, htmlBefore = event.htmlBefore;
    var html = event.clipboardData.html;
    if (html.match(LAST_TD_END_REGEX)) {
        var trMatch = htmlBefore.match(LAST_TR_REGEX);
        var tr = trMatch ? trMatch[0] : '<TR>';
        html = tr + html + '</TR>';
    }
    if (html.match(LAST_TR_END_REGEX)) {
        var tableMatch = htmlBefore.match(LAST_TABLE_REGEX);
        var table = tableMatch ? tableMatch[0] : '<TABLE>';
        html = table + html + '</TABLE>';
    }
    if (event.clipboardData.html != html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        while (fragment.firstChild) {
            fragment.removeChild(fragment.firstChild);
        }
        while ((_a = doc === null || doc === void 0 ? void 0 : doc.body) === null || _a === void 0 ? void 0 : _a.firstChild) {
            fragment.appendChild(doc.body.firstChild);
        }
    }
    roosterjs_editor_dom_1.chainSanitizerCallback(sanitizingOption.elementCallbacks, 'TD', function (element) {
        if (element.style.borderStyle == 'none') {
            element.style.border = DEFAULT_BORDER_STYLE;
        }
        return true;
    });
}
exports.default = convertPastedContentFromExcel;
//# sourceMappingURL=convertPastedContentFromExcel.js.map